
import { defineComponent, reactive, watch } from 'vue'

type Props = {
  checked: {
    value: string;
    label: string;
  };
  unchecked: {
    value: string;
    label: string;
  };
  value: string;
}

type State = {
  check: boolean;
}

export default defineComponent({
  props: {
    checked: {
      type: Object as () => Props['checked'],
      default: null,
      required: true
    },
    unchecked: {
      type: Object as () => Props['unchecked'],
      default: null,
      required: true
    },
    value: {
      type: String as () => Props['value'],
      default: ''
    }
  },
  emits: ['change'],
  setup (props: Props, { emit }) {
    const state = reactive<State>({
      check: props.value === props.checked.value
    })

    watch(() => state.check, () => {
      emit('change', state.check ? props.checked.value : props.unchecked.value)
    })

    return {
      state,
      props
    }
  }
})
